"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _reactPopper = require("react-popper");
var _NavIcon = _interopRequireDefault(require("./NavIcon"));
var _Context = require("../../Context");
var _ClickOutside = _interopRequireDefault(require("../../../../components/ClickOutside"));
var _Notification = _interopRequireDefault(require("./icons/Notification"));
var _BellWidget = _interopRequireDefault(require("../../BellWidget"));
var actions = _interopRequireWildcard(require("../../../actions"));
var _appconfig = require("../../../selectors/appconfig");
var _notifications = require("../../../selectors/notifications");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getModifiers = theme => [{
  name: 'offset',
  enabled: true,
  options: {
    offset: [0, theme === 'mds' ? 22 : 8]
  }
}];
const Notifications = ({
  title,
  disabled
}) => {
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const notifications = (0, _Context.useSelector)(_notifications.getNotifications);
  const isNotificationsExpanded = (0, _Context.useSelector)(_notifications.isWidgetExpanded);
  const hasUnread = (0, _Context.useSelector)(_notifications.hasNewNotifications);
  const hasMoreNotifications = (0, _Context.useSelector)(_notifications.getNextToken);
  const theme = (0, _styledComponents.useTheme)();
  const dispatch = (0, _Context.useDispatch)();
  const openWidget = () => {
    dispatch(actions.showNotificationsWidget());
  };
  const hideWidget = () => {
    dispatch(actions.hideNotificationsWidget());
  };
  const loadNextPage = () => {
    dispatch(actions.getNotificationsPending());
  };
  const handleReadNotification = ({
    notification,
    conflictMsg,
    callback
  }) => {
    if (!notification.isRead) {
      return dispatch(actions.updateNotificationPending(notification, conflictMsg, callback));
    }
    return callback();
  };
  const openNotificationCenter = () => {
    hideWidget();
    window.location = `${appconfig.accountPrefix === '/' ? '' : appconfig.accountPrefix}/notifications`;
  };
  return _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Reference, null, ({
    ref
  }) => _react.default.createElement(_NavIcon.default, {
    innerRef: ref,
    title: title,
    hasBadge: hasUnread,
    action: isNotificationsExpanded ? hideWidget : openWidget,
    disabled: disabled
  }, _react.default.createElement(_Notification.default, null))), isNotificationsExpanded && _react.default.createElement(_ClickOutside.default, {
    onClickOutside: hideWidget
  }, _react.default.createElement(_reactPopper.Popper, {
    placement: "bottom",
    modifiers: getModifiers(theme.name)
  }, ({
    ref,
    style,
    placement,
    arrowProps
  }) => _react.default.createElement(_BellWidget.default, {
    innerRef: ref,
    style: style,
    placement: placement,
    notifications: notifications,
    seeAllAction: openNotificationCenter,
    onReadNotification: handleReadNotification,
    localeData: locale,
    loadNextNotifications: loadNextPage,
    hasMoreNotifications: hasMoreNotifications,
    arrow: arrowProps
  }))));
};
var _default = exports.default = Notifications;